'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = map;

var _frame = require('../frame');

function map(state, action) {
    return (0, _frame.FrameReducer)(state, action);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvbWFwaW8vTWFwUmVkdWNlci5qc3giXSwibmFtZXMiOlsibWFwIiwic3RhdGUiLCJhY3Rpb24iXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUV3QkEsRzs7QUFGeEI7O0FBRWUsU0FBU0EsR0FBVCxDQUFhQyxLQUFiLEVBQW9CQyxNQUFwQixFQUE0QjtBQUN2QyxXQUFPLHlCQUFhRCxLQUFiLEVBQW9CQyxNQUFwQixDQUFQO0FBQ0giLCJmaWxlIjoiTWFwUmVkdWNlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7RnJhbWVSZWR1Y2VyfSBmcm9tICcuLi9mcmFtZSdcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gbWFwKHN0YXRlLCBhY3Rpb24pIHtcbiAgICByZXR1cm4gRnJhbWVSZWR1Y2VyKHN0YXRlLCBhY3Rpb24pO1xufVxuIl19